import React from 'react';
import RecentContent from '@/components/MobileApproval/SearchModal/RecentApproval/RecentContent';
import { useTranslation } from 'react-i18next';
import { useTalkFlowRecentlyViewedList } from '@/hooks/apiHooks/legacyApiHooks';
import { EMPTY_SUBJECT } from '@/components/Record/util/function';
import { StyledTitle } from '../RecentApproval/styles';

const RecentDocument = () => {
  const { data } = useTalkFlowRecentlyViewedList();
  const { t } = useTranslation();

  const sendPostMessage = (docId: string) => {
    const sendData = JSON.stringify({
      actionType: 'MODAL',
      tabName: 'document',
      docId: docId,
    });
    window?.ReactNativeWebView?.postMessage(sendData);
  };

  return (
    <div style={{ marginTop: '20px', padding: '0px 8px' }}>
      {data && data.length > 0 && (
        <div style={{ marginTop: '28px' }}>
          <StyledTitle>{t('최근 본 문서')}</StyledTitle>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '24px',
              marginTop: '8px',
            }}
          >
            {data.map((res, idx) => (
              <RecentContent
                key={`recent-read-document-${idx}`}
                docId={res.talkFlowDocumentId}
                subject={res.subject ?? t(EMPTY_SUBJECT)}
                authoredAt={res.createdAt}
                author={res.author}
                sendPostMessage={sendPostMessage}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default RecentDocument;
